<template>
    <form>
        <div class="form-section">
            <label>Question posée</label>
            <input type="text" v-model="label">
        </div>

        <div class="form-section">
            <label>Difficulté</label>
            <select v-model="difficulty">
                <option :value="1">Intermédiaire</option>
                <option :value="2">Confirmé</option>
                <option :value="3">Expert</option>
                <option :value="4">Expert+</option>
            </select>
        </div>

        <div class="form-section">
            <h3>Options <span class="material-symbols-outlined" @click="addOption">add_circle</span></h3>
            <table class="options">
                <tr v-for="(option, index) in options" :key="index">
                    <td>
                        <input type="checkbox" v-model="option.is_valid">
                    </td>

                    <td>
                        <input type="text" placeholder="option x..." v-model="option.text">
                    </td>

                    <td>
                        <span class="material-symbols-outlined" @click="deleteOption(index)">delete_forever</span>
                    </td>
                </tr>
            </table>
        </div>

        <div class="form-section">
            <label>Réponse expliquée</label>
            <textarea v-model="answer_text"></textarea>
        </div>

        <div class="btn-wrapper">
            <div :class="{'allowed-btn': hasValidBody }" @click="createQuestions">Enregistrer</div>
        </div>
    </form>
</template>

<script>
import axios from 'axios';
export default {
    data() {
        return {
            categoryId: undefined,
            label: "",
            difficulty: 1,
            multi: false,
            options: [],
            answer_text: "",
        }
    },
    computed: {
        body() {
            return {
                categoryId: this.$route.params.categoryId,
                label: this.label,
                difficulty: this.difficulty,
                options: this.options,
                answer_text: this.answer_text,
            }
        },
        hasValidBody() {
            if (!this.label) return false;
            else if (!this.difficulty) return false;
            else if (this.options.length < 2) return false;
            else if (!this.answer_text || this.answer_text == '') return false;
            else return true;
        }
    },
    methods: {
        addOption() {
            this.options.push({
                text: "",
                is_valid: false,
            });
        },
        deleteOption(index) {
            this.options.splice(index, 1);
        },
        async createQuestions() {
            if (!this.hasValidBody) return;

            const result = await axios.post(this.$store.getters.get_api_url + 'academy/questions/', this.body);
            this.$emit('closeForm', result.data);
        },
    }
}
</script>

<style scoped>
.form-section {
    flex-wrap: wrap;
}

.form-section label,
.form-section input,
.form-section select,
.form-section textarea {
    font-size: 12px;
}

.form-section label {
    font-weight: bold;
    flex-basis: 100%;
}

.form-section textarea {
    border: 1px solid lightgrey;
    border-radius: 10px;
    flex-basis: 100%;
    height: 150px;
    padding: 10px;
}

.form-section h3 .material-symbols-outlined:hover {
    cursor: pointer;
    color: #FB984B;
}

table.options {
    width: 100%;
}

table.options td {
    position: relative;
    text-align: center;
    vertical-align: middle;
    height: 30px;
    line-height: 30px;
}

table.options td input[type="checkbox"] {
    vertical-align: middle;
    height: 20px;
    width: 20px;
}

table.options td:nth-child(2) {
    width: 100%;
}

table.options td:nth-child(2) input {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 10px;
    border: none;
    text-align: left;
}

table.options td .material-symbols-outlined:hover {
    cursor: pointer;
    color: red;
}

.btn-wrapper {
    padding: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.btn-wrapper div {
    cursor: not-allowed;
    padding: 15px;
    border-radius: 10px;
    background-color: lightgrey;
    font-weight: bold;
}
.btn-wrapper div.allowed-btn {
    cursor: pointer;
    background-color: #FB984B;
    color: white;
}
</style>